import { CustomField } from '@fullstory/search-vars';
import {
  DefinedEventRecord,
  NamedElementRecord,
} from '@fullstory/proto/fs/services/search-settings';
import { PageDefinition } from '@fullstory/proto/fs/api/pages';
import { BySlug, SpecObjectInfo } from '../specs';

export enum SearchMetaTypes {
  GetCustomSchemaRequest = 'searchmeta.customschema.request',
  GetCustomSchemaSuccess = 'searchmeta.customschema.success',
  GetCustomSchemaFailure = 'searchmeta.customschema.failure',
  GetCustomSchemaConnectionsRequest = 'searchmeta.customschemaconns.request',
  GetCustomSchemaConnectionsSuccess = 'searchmeta.customschemaconns.success',
  GetCustomSchemaConnectionsFailure = 'searchmeta.customschemaconns.failure',
  GetCustomSchemaConnectionsByPropertyRequest = 'searchmeta.customschemaconns.byprop.request',
  GetCustomSchemaConnectionsByPropertySuccess = 'searchmeta.customschemaconns.byprop.success',
  GetCustomSchemaConnectionsByPropertyFailure = 'searchmeta.customschemaconns.byprop.failure',
  MarkConnectionsLoading = 'searchmeta.markconnsloading',
  MarkConnectionsByPropertyLoading = 'searchmeta.markconns.byprop.loading',
  UpdateVarsRequest = 'searchmeta.sethiddenvars.request',
  UpdateVarsSuccess = 'searchmeta.sethiddenvars.success',
  UpdateVarsFailure = 'searchmeta.sethiddenvars.failure',
  GetHiddenVarsRequest = 'searchmeta.gethiddenvars.request',
  GetHiddenVarsSuccess = 'searchmeta.gethiddenvars.success',
  GetHiddenVarsFailure = 'searchmeta.gethiddenvars.failure',
}

export interface SearchCacheKey {
  definedEventVersionsHash: number;
  namedElementVersionsHash: number;
  specObjectVersionsHash: number;
}

export interface SearchContext {
  customEventNames: string[];
  hiddenCustomEventNames: string[];
  customEventProps: Map<string, CustomField[]>;
  hiddenCustomEventProps: CustomField[];
  definedEvents: Map<string, DefinedEventRecord>;
  namedElements: Map<string, NamedElementRecord>;
  watchedNamedElementIds: Set<string>;
  userVars: CustomField[];
  hiddenUserVars: CustomField[];
  pageProps: Map<number, CustomField[]>;
  hiddenPageProps: CustomField[];
  pageDefinitions: Map<number, PageDefinition>;
  elementProps: Map<string, CustomField[]>;
  hiddenElementProps: CustomField[];
  specObjects: BySlug<SpecObjectInfo>;
  specTopUnmapped: SpecObjectInfo[];
  sidebar?: boolean;
  fsevtVars: CustomField[];
  hiddenFsevtVars: CustomField[];
}

export interface ApiEventDetails {
  name: string;
  archived: boolean;
}
